/*
 * Hamburger Messages
 *
 * This contains all the text for the Hamburger component.
 */

import { defineMessages } from "react-intl";

export const scope = "app.components.Hamburger";

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: "This is the Hamburger component!",
  },
  adminPage: {
    id: `${scope}.adminPage`,
    defaultMessage: "Admin page",
  },
  practice: {
    id: `${scope}.editUser`,
    defaultMessage: "Practice",
  },
});
